import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { BarChart, Refresh } from '@mui/icons-material';

interface ChartErrorFallbackProps {
  onRetry?: () => void;
  title?: string;
  message?: string;
}

const ChartErrorFallback: React.FC<ChartErrorFallbackProps> = ({
  onRetry,
  title = 'Chart Error',
  message = 'Failed to load chart data',
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={3}
      sx={{
        backgroundColor: 'var(--liftstatus-background)',
        borderRadius: '12px',
        border: '1px solid var(--liftstatus-border-light)',
        minHeight: 200,
      }}
    >
      <BarChart
        sx={{
          fontSize: 48,
          color: 'var(--liftstatus-grey)',
          mb: 2,
          opacity: 0.5,
        }}
      />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        mb={2}
      >
        {message}
      </Typography>
      {onRetry && (
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={onRetry}
          size="small"
          sx={{
            borderColor: 'var(--liftstatus-primary-color)',
            color: 'var(--liftstatus-primary-color)',
            '&:hover': {
              borderColor: 'var(--liftstatus-primary-color-dark)',
              backgroundColor: 'rgba(134, 178, 156, 0.08)',
            },
          }}
        >
          Retry
        </Button>
      )}
    </Box>
  );
};

export default ChartErrorFallback;
